import { SET_VIDEO_STORE, GET_VIDEO_STORE, REMOVE_VIDEO_STORE } from './types';
import { storage } from '@/utils/storage';

const state = () => ({
  video: JSON.parse(storage.getItem('video') || null),
});

const getters = {
  [GET_VIDEO_STORE]: (state: any) => state.video,
};

const mutations = {
  [SET_VIDEO_STORE](state: any, video: string) {
    state.video = video;
  },
  [REMOVE_VIDEO_STORE](state: any) {
    state.video = null;
  },
};

const actions = {
  [SET_VIDEO_STORE](context: any, video: any) {
    storage.setItem('video', JSON.stringify(video));
    context.commit(SET_VIDEO_STORE, video);
  },
  [REMOVE_VIDEO_STORE](context: any) {
    storage.removeItem('video');
    context.commit(REMOVE_VIDEO_STORE);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
